require('./bootstrap');

import { createApp, h } from 'vue';
import { createInertiaApp, Link } from '@inertiajs/inertia-vue3';
import { InertiaProgress } from '@inertiajs/progress';
import ElementPlus from 'element-plus';
import locale from 'element-plus/lib/locale/lang/ru';

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';

import UiBackButton from '@/components/Ui/UiBackButton';
import UiSidebar from '@/components/Ui/UiSidebar';
import UiAddButton from '@/components/Ui/UiAddButton';
import BaseLayout from './Layouts/BaseLayout';
import FormatMoney from './components/Format/FormatMoney';
import UiBreadcrumbs from './components/Ui/UiBreadcrumbs';

createInertiaApp({
  title: (title) => `${title} - ${appName}`,
  resolve: (name) => {
    if (name.startsWith('@')) {
      const page = name.split('/');
      const module = page.shift().substr(1);
      // eslint-disable-next-line global-require,import/no-dynamic-require
      return require(`@modules/${module}/Resources/Pages/${page.join('/')}.vue`);
    }
    // eslint-disable-next-line global-require,import/no-dynamic-require
    return require(`./Pages/${name}.vue`);
  },
  setup({
    el, app, props, plugin,
  }) {
    const vueApp = createApp({ render: () => h(app, props) })
      .use(ElementPlus, { locale })
      .use(plugin)
      .mixin({ methods: { route } });

    vueApp.component('UiBackButton', UiBackButton);
    vueApp.component('UiSidebar', UiSidebar);
    vueApp.component('UiAddButton', UiAddButton);
    vueApp.component('BaseLayout', BaseLayout);
    vueApp.component('UiBreadcrumbs', UiBreadcrumbs);

    vueApp.component('FormatMoney', FormatMoney);

    vueApp.component('InertiaLink', Link);

    return vueApp.mount(el);
  },
});

InertiaProgress.init({ color: '#00B380' });
